// ============================================
// COVRFLY UX - Bloque Envío v2.3 + Animación Sweet Spot 1.7s
// Fusión: diseño v2.3 + animación original
// ============================================
(function() {
  
  // 1) ELIMINAR TEXTO IVA
  document.querySelectorAll('.product__tax').forEach(el => el.style.display = 'none');
  
  // 2) CONFIGURACIÓN
  const CONFIG = {
    timezone: 'America/Mexico_City',
    cutOffHour: 16,
    urgencyThresholdHours: 3,
    productionDays: 0,
    shipping: {
      standard: { name: 'Estándar', min: 6, max: 8 },
      priority: { name: 'Prioritario', min: 3, max: 5 },
      express:  { name: 'Express', min: 2, max: 3 }
    }
  };

  // 3) FESTIVOS MX
  const HOLIDAYS_FIXED = ['01-01','02-05','03-20','05-01','09-16','11-20','12-12','12-24','12-25','12-31'];
  
  function getEasterDates(year) {
    const a = year % 19, b = Math.floor(year / 100), c = year % 100;
    const d = Math.floor(b / 4), e = b % 4, f = Math.floor((b + 8) / 25);
    const g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30;
    const i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7;
    const m = Math.floor((a + 11 * h + 22 * l) / 451);
    const month = Math.floor((h + l - 7 * m + 114) / 31);
    const day = ((h + l - 7 * m + 114) % 31) + 1;
    const easter = new Date(year, month - 1, day);
    const jueves = new Date(easter); jueves.setDate(easter.getDate() - 3);
    const viernes = new Date(easter); viernes.setDate(easter.getDate() - 2);
    return [jueves, viernes];
  }

  function getHolidays(year) {
    const holidays = HOLIDAYS_FIXED.map(d => `${year}-${d}`);
    const [j, v] = getEasterDates(year);
    const fmt = d => `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`;
    holidays.push(fmt(j), fmt(v));
    return holidays;
  }

  // 4) FUNCIONES FECHA
  function nowMX() { return new Date(new Date().toLocaleString('en-US', { timeZone: CONFIG.timezone })); }
  
  function isBiz(date) {
    const day = date.getDay();
    if (day === 0 || day === 6) return false;
    const y = date.getFullYear(), m = String(date.getMonth()+1).padStart(2,'0'), d = String(date.getDate()).padStart(2,'0');
    return !getHolidays(y).includes(`${y}-${m}-${d}`);
  }
  
  function nextBiz(date) { const x = new Date(date); do { x.setDate(x.getDate()+1); } while (!isBiz(x)); return x; }
  function addBiz(base, n) { let d = new Date(base), r = n; while (r > 0) { d.setDate(d.getDate()+1); if (isBiz(d)) r--; } return d; }
  
  function fmtRange(s, e) {
    const sd = s.getDate(), ed = e.getDate();
    const sm = new Intl.DateTimeFormat('es-MX',{month:'short'}).format(s).replace('.','');
    const em = new Intl.DateTimeFormat('es-MX',{month:'short'}).format(e).replace('.','');
    return sm === em ? `Llega ${sd}–${ed} ${em}` : `Llega ${sd} ${sm} – ${ed} ${em}`;
  }

  // 5) CALCULAR FECHAS
  let now = nowMX(), cutoff = new Date(now);
  cutoff.setHours(CONFIG.cutOffHour, 0, 0, 0);
  let start = now < cutoff ? now : nextBiz(now);
  if (!isBiz(start)) start = nextBiz(start);
  start.setHours(0,0,0,0);
  const R = {
    std: { s: addBiz(start, CONFIG.shipping.standard.min), e: addBiz(start, CONFIG.shipping.standard.max) },
    pri: { s: addBiz(start, CONFIG.shipping.priority.min), e: addBiz(start, CONFIG.shipping.priority.max) },
    exp: { s: addBiz(start, CONFIG.shipping.express.min), e: addBiz(start, CONFIG.shipping.express.max) }
  };

  function getTimeToCutoff() {
    const n = nowMX(); let c = new Date(n);
    c.setHours(CONFIG.cutOffHour,0,0,0);
    if (n >= c) c = nextBiz(c);
    else if (!isBiz(n)) c = nextBiz(n);
    c.setHours(CONFIG.cutOffHour,0,0,0);
    const diff = c - n;
    return { hrs: Math.floor(diff/36e5), min: Math.floor((diff%36e5)/6e4), total: diff/36e5 };
  }

  // 6) RENDER BLOQUE ENVÍO v2.3
  const box = document.querySelector('.delivery-container');
  if (!box) { console.warn('⚠️ No .delivery-container'); return; }

  const time = getTimeToCutoff();
  const showTimer = time.total <= CONFIG.urgencyThresholdHours;

  const ICONS = {
    truck: `<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="1" y="3" width="15" height="13"/><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg>`,
    plane: `<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M21 16v-2l-8-5V3.5c0-.83-.67-1.5-1.5-1.5S10 2.67 10 3.5V9l-8 5v2l8-2.5V19l-2 1.5V22l3.5-1 3.5 1v-1.5L13 19v-5.5l8 2.5z"/></svg>`,
    bolt: `<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></svg>`
  };

  box.innerHTML = `
    <div class="cvr-header anim-item">
      ${showTimer ? `<div class="cvr-header-row"><span class="cvr-dot"></span><span class="cvr-header-text">Ordena en <strong>${time.hrs > 0 ? time.hrs + "h " : ""}${time.min}m</strong> para recibir en:</span></div>` : `<span class="cvr-header-text">Entrega estimada:</span>`}
    </div>
    <div class="cvr-list">
      <div class="cvr-row anim-item"><div class="cvr-icon">${ICONS.truck}</div><div class="cvr-info"><div class="cvr-name">Estándar</div><div class="cvr-date">${fmtRange(R.std.s, R.std.e)}</div></div><div class="cvr-badge cvr-badge-free">Sin costo*</div></div>
      <div class="cvr-row anim-item"><div class="cvr-icon">${ICONS.plane}</div><div class="cvr-info"><div class="cvr-name">Prioritario</div><div class="cvr-date">${fmtRange(R.pri.s, R.pri.e)}</div></div></div>
      <div class="cvr-row anim-item"><div class="cvr-icon">${ICONS.bolt}</div><div class="cvr-info"><div class="cvr-name">Express</div><div class="cvr-date">${fmtRange(R.exp.s, R.exp.e)}</div></div><div class="cvr-badge cvr-badge-fast">Llega antes</div></div>
    </div>
    <div class="cvr-disclaimer anim-item">*Sin costo en 2+ cases \u00B7 Tiempos estimados</div>
  `;

  // 7) CSS v2.3 + ANIMACIÓN SWEET SPOT 1.7s
  const css = `
    .delivery-container{all:unset!important;display:block!important;background:#fafafa!important;border:1px solid #e5e5e5!important;border-radius:12px!important;padding:16px!important;max-width:100%!important;margin:0 0 16px 0!important;color:#111!important;font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,sans-serif!important;box-sizing:border-box!important;opacity:0;transform:translateY(40px);transition:opacity 1.7s cubic-bezier(0.19,1,0.22,1),transform 1.7s cubic-bezier(0.19,1,0.22,1)}
    .delivery-container.in-view{opacity:1!important;transform:translateY(0)!important}
    .anim-item{opacity:0;transform:translateY(20px);transition:opacity 1.7s cubic-bezier(0.19,1,0.22,1),transform 1.7s cubic-bezier(0.19,1,0.22,1)}
    .delivery-container.in-view .cvr-header.anim-item{transition-delay:0.15s;opacity:1!important;transform:translateY(0)!important}
    .delivery-container.in-view .cvr-list .anim-item:nth-child(1){transition-delay:0.40s;opacity:1!important;transform:translateY(0)!important}
    .delivery-container.in-view .cvr-list .anim-item:nth-child(2){transition-delay:0.65s;opacity:1!important;transform:translateY(0)!important}
    .delivery-container.in-view .cvr-list .anim-item:nth-child(3){transition-delay:0.90s;opacity:1!important;transform:translateY(0)!important}
    .delivery-container.in-view .cvr-disclaimer.anim-item{transition-delay:1.15s;opacity:1!important;transform:translateY(0)!important}
    .cvr-header{padding-bottom:12px!important;border-bottom:1px solid #e5e5e5!important;margin-bottom:12px!important}
    .cvr-header-row{display:flex!important;align-items:center!important;gap:8px!important}
    .cvr-dot{width:8px!important;height:8px!important;background:#22c55e!important;border-radius:50%!important;display:inline-block!important;animation:cvr-pulse 2s infinite!important}
    @keyframes cvr-pulse{0%,100%{box-shadow:0 0 0 0 rgba(34,197,94,0.7)}50%{box-shadow:0 0 0 6px rgba(34,197,94,0)}}
    .cvr-header-text{font-size:16px!important;color:#000!important;font-weight:700!important}
    .cvr-header-text strong{font-weight:700!important}
    .cvr-list{display:flex!important;flex-direction:column!important;gap:0!important}
    .cvr-row{display:flex!important;align-items:center!important;padding:12px 0!important;border-bottom:1px solid #f0f0f0!important;gap:12px!important}
    .cvr-row:last-child{border-bottom:none!important;padding-bottom:0!important}
    .cvr-row:first-child{padding-top:0!important}
    .cvr-icon{width:24px!important;height:24px!important;flex-shrink:0!important;display:flex!important;align-items:center!important;justify-content:center!important;color:#333!important}
    .cvr-icon svg{width:20px!important;height:20px!important}
    .cvr-info{flex:1!important;min-width:0!important}
    .cvr-name{font-size:14px!important;font-weight:600!important;color:#171717!important;line-height:1.3!important}
    .cvr-date{font-size:13px!important;color:#525252!important;margin-top:2px!important}
    .cvr-badge{font-size:11px!important;font-weight:500!important;padding:4px 10px!important;border-radius:4px!important;white-space:nowrap!important}
    .cvr-badge-free{background:#dcfce7!important;color:#166534!important}
    .cvr-badge-fast{background:#FDEAB6!important;color:#7A5D0F!important}
    .cvr-disclaimer{margin-top:12px!important;padding-top:10px!important;border-top:1px solid #f0f0f0!important;font-size:11px!important;color:#9ca3af!important;text-align:center!important}
    .product-form__submit,.product-form__submit.button,button[name="add"]{width:100%!important;max-width:100%!important;height:52px!important;background:#0470E3!important;color:#fff!important;border:none!important;border-radius:12px!important;font-size:16px!important;font-weight:600!important;display:flex!important;align-items:center!important;justify-content:center!important;gap:8px!important;cursor:pointer!important}
    .product__add__cart__button,.product-form__buttons,.product-form__cart--box{width:100%!important}
  `;
  
  let styleEl = document.getElementById('cvr-css');
  if (styleEl) styleEl.remove();
  styleEl = document.createElement('style');
  styleEl.id = 'cvr-css';
  styleEl.textContent = css;
  document.head.appendChild(styleEl);

  // 8) MOVER BLOQUE ANTES DEL CTA
  const addToCartBtn = document.querySelector('.product-form__submit');
  if (addToCartBtn) {
    const contenedorBtn = addToCartBtn.closest('.product-form__cart--box') || addToCartBtn.closest('.product-form__buttons');
    if (contenedorBtn) {
      contenedorBtn.parentNode.insertBefore(box, contenedorBtn);
      box.style.marginBottom = '16px';
      console.log('✅ Bloque envío movido antes del CTA');
    }
  }

  // 9) INTERSECTION OBSERVER (activa animación al scroll)
  requestAnimationFrame(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          box.classList.add('in-view');
          observer.unobserve(box);
          console.log('✅ Animación activada por scroll');
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -50px 0px' });

    observer.observe(box);
  });

  console.log('✅ COVRFLY Bloque Envío v2.3 + Animación 1.7s');


  // Anti-FOUC v2.0: señal al orquestador
  window.cfPdpDone && window.cfPdpDone('delivery');

})();
